
import menu from './menu/menuDirective';
import home from "./modules/home/home";
import logout from "./modules/logout/logout";
import settings from "./modules/settings/settings";
import help from "./modules/help/help";
import print from './modules/print/print';
import ngRouter from '@uirouter/angularjs';
import uiBootstrap from 'angular-ui-bootstrap';
import ngDialogLib from 'ng-dialog';

import Raven from 'raven-js';
window.Raven = Raven;

let tag;

tag = 'PROD';

Raven.config('https://64bb7c351ad74fda906cf843a41320e9@fail.mathesio.com/6',
	{
		environment: tag,
		debug: true,
		release: 'web-autovraky-2.1.3'
	}).install();

import 'angular-raven';

import appName from './appName';
import carsService from "./services/carsService/carsService";

angular.module('app', [
	 'appTemplates',
	home,
	logout,
	settings,
	menu,
	help,
	ngRouter,
	uiBootstrap,
	'ui-notification',
	ngDialogLib,
	'mwl.confirm',
	print,
	'pascalprecht.translate',
	'logglyLogger',
	'ngRaven',
	carsService
]).config(function($stateProvider, $urlRouterProvider, NotificationProvider, $uibTooltipProvider, ngDialogProvider, $translateProvider, $ravenProvider) {
	$urlRouterProvider.otherwise('/home');
	
	NotificationProvider.setOptions({
		delay: 20000,
		startTop: 20,
		startRight: 10,
		verticalSpacing: 20,
		horizontalSpacing: 20,
		positionX: 'left',
		positionY: 'bottom'
	});
	
	$uibTooltipProvider.options({appendToBody: true});
	
	ngDialogProvider.setDefaults({
		className: "ngdialog-theme-default",
		plain: false,
		showClose: true,
		closeByDocument: true,
		closeByEscape: true,
		appendTo: false
	});
	
	ngDialogProvider.setOpenOnePerName(true);
	
	$translateProvider.translations('cz',
		{
			"Search": "Vyhledat",
			"Page": "stránka",
			"First Page": "První stránka",
			"Next Page": "Poslední stránka",
			"Previous Page": "Předchozí",
			"Last Page": "Následující",
			"Sort": "Seřadit",
			"No items to display": "Žádné položky",
			"displayed": "zobrazeno",
			"in total": "celkově"
		});
	
	$translateProvider.preferredLanguage('cz');
	$translateProvider.useSanitizeValueStrategy('escape');
	
	$ravenProvider.development(false);
	
	$stateProvider.state('autovraky', {
		url: '/',
		abstract: true,
		resolve: {
			justLoadIt: function(carsService) {
				return carsService.loadCarsFromStorage();
			}
		}
	});
}).run(function(confirmationPopoverDefaults) {
	confirmationPopoverDefaults.confirmText = 'Ano';
	confirmationPopoverDefaults.cancelText = 'Ne';
	confirmationPopoverDefaults.animation = true;
	confirmationPopoverDefaults.cancelButtonType = 'danger';
}).controller('AppController', function($scope, $log, ngDialog, userService, maIsoh, notify, $rootScope, $state) {

	/**
	 * Opens wizard
	 */
	this.openWizard = () => {
		ngDialog.open({
			template: 'modules/home/welcomeWizard.tpl.html',
			controller: 'WelcomeWizardController',
			controllerAs: 'ctrl',
			name: 'welcomeWizardDialog',
			closeByEscape: false,
			closeByNavigation: false,
			closeByDocument: false,
			showClose: false,
			width: '75%'
		}).closePromise.then((response) => {
			if (response.value && response.value != '$closeButton') {
				userService.introWizardDone();
				$rootScope.$broadcast('loadCarsFromISOH');
			}
		});
	};
	
	this.appName = appName;
	
	/**
	 * Should we display intro wizard?
	 */
	if (userService.displayIntro()) {
		this.openWizard();
	}
	
	let logoutEntry = {name: 'Odhlásit', link: 'logout', icon: 'fa fa-sign-out'};
	
	let refreshMenuFacility = () => {
		logoutEntry.name = 'Odhlásit (zařízení: ' + userService.getUserSettings().workplace.nazev + ')';
	};
	refreshMenuFacility();
	$scope.$on('loginOk', refreshMenuFacility);


	const appMessages = () => {
		maIsoh.loadAppMessages().then((response) => {
			if(response.json.zpravy.item.length > 0) {
				let formattedMessage = '';
				for(const message of response.json.zpravy.item) {
					formattedMessage += '<p class="border-bottom">' + message + '</p>'
				}
				notify.info(formattedMessage);
			}
		})
	}
	if(maIsoh.user) {
		appMessages();
	}

	$scope.$on('loginOk', appMessages);

	this.menu = [
		{name: 'Domů', link: 'autovraky.home', icon: 'fa fa-home'},
		{name: 'Nastavení', link: 'autovraky.settings', icon: 'fa fa-cog'},
		{name: 'Podpora', link: 'autovraky.help', icon: 'fa fa-question'}
		, logoutEntry
	];
	
	this.hideMenu = false;
	
	$scope.$on('hideMenu', () => {
		this.hideMenu = true;
	});
	
	$scope.$on('showMenu', () => {
		this.hideMenu = false;
	});
	
	$log.info('Aplikace spustena!');
	
	// maIsohService.setUser(userService.getUser());
	// maIsohService.setAPIUrl()
});



// WEBPACK FOOTER //
// build/app.js